import axiosInst from "api/config/axiosConfig";
import { DemoUserAddTypes, DemoUserTypes, setUserIsDisabledTypes, UserRequestType } from "./demo-users.config";

export const userStatus = {
  disable: "disable",
  extend: "extend",
};

export const addDemoUsers = async (user: DemoUserAddTypes) => {
  const response = await axiosInst.post("/beta/usersAdd", user);
  return response.data;
};

export const getDemoUsers = async (user: UserRequestType): Promise<{ users: DemoUserTypes[]; totalCount: number }> => {
  const response = await axiosInst.post("/beta/usersList", { ...user, includeExpiration: true });
  return {
    users: response.data.Users || [],
    totalCount: response.data.TotalCount || 0,
  };
};

export const getDemoDevices = async () => {
  const response = await axiosInst.get("/beta/appSystemInfo?demodevices=all");
  return response.data;
};

export const getUserDevices = async (userId: string) => {
  const response = await axiosInst.get(`/beta/appSystemInfo?demouser=${userId}`);
  return response.data;
};

export const updateDemoDevices = async (body: any) => {
  const response = await axiosInst.put("/beta/appSystemInfo", body);
  return response.data;
};

export const updateAssignedDevices = async (body: any) => {
  const response = await axiosInst.put("/beta/appSystemInfo", body);
  return response.data;
};

export const setUserIsDisabled = async (body: setUserIsDisabledTypes) => {
  const response = await axiosInst.post("/beta/userEnableDisable", body);
  return response.data;
};

export const deleteDemoUser = async (body: setUserIsDisabledTypes) => {
  const response = await axiosInst.post("/beta/userDelete", body);
  return response.data;
};
